import type { Task } from '../types/project';

export function projectLabel(task: Task): string {
  if (!task.theme_name) return '';
  return task.parent_theme_name ? `${task.parent_theme_name} > ${task.theme_name}` : task.theme_name;
}
